import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import AwaitRestartView from './AwaitRestartView';

class AwaitRestart extends React.Component {
	constructor(props) {
		super(props);
		this.retryAwaitRestart = this.retryAwaitRestart.bind(this);
	}

	retryAwaitRestart() {
		this.props.actions.awaitRestart();
	}

	render() {
		const { showDialog, restarting, error, errorDetail, timeout } = this.props;
		if (!showDialog || (!restarting && !error && !timeout)) {
			return null;
		}
		return (
			<AwaitRestartView
				restarting={restarting}
				error={error}
				errorDetail={errorDetail}
				timeout={timeout}
				onRetry={this.retryAwaitRestart}
			/>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		showDialog: state.restart.showDialog,
		restarting: state.restart.restarting,
		timeout: state.restart.timeout,
		error: state.restart.error,
		errorDetail: state.restart.errorDetail
	};
}

AwaitRestart.propTypes = {
	showDialog: PropTypes.bool,
	restarting: PropTypes.bool,
	timeout: PropTypes.bool,
	error: PropTypes.bool,
	errorDetail: PropTypes.object
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AwaitRestart);
